/* Memories Parfums — mejoras de tarjetas (Galería de Recuerdos) */
(function () {
  var WORDS = {
    intensidad: { 5: 'Muy alta', 4: 'Alta', 3: 'Moderada', 2: 'Suave', 1: 'Ligera' },
    duracion: { 5: 'Muy larga', 4: 'Larga', 3: 'Media', 2: 'Corta', 1: 'Breve' }
  };
  var products = {};
  var downX = 0, downY = 0;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function getProduct(handle) {
    if (!products[handle]) {
      products[handle] = fetch(root() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return products[handle];
  }

  function handleOf(card) {
    var href = card.getAttribute('href') || '';
    var part = href.split('/products/')[1];
    return part ? part.split(/[?#/]/)[0] : '';
  }

  var SET_INFO = [
    ['Incluye', '9 fragancias'],
    ['Bonificación', '$250 MXN', 'en tu siguiente botella']
  ];
  var NO_MSI = { 'set-recuerdos': true };

  function formatMoney(n) {
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function enhanceMsi(card) {
    if (card.getAttribute('data-mp-msi') || NO_MSI[handleOf(card)]) return;
    var price = card.querySelector('.mp-home-price');
    if (!price) return;
    var amount = parseFloat((price.textContent || '').replace(/[^0-9.]/g, ''));
    if (!amount) return;
    card.setAttribute('data-mp-msi', '1');
    var line = document.createElement('p');
    line.className = 'mp-card-msi';
    line.innerHTML = '<span>6 meses sin intereses</span><small>' + formatMoney(amount / 6) + ' al mes</small>';
    price.parentNode.insertBefore(line, price.nextSibling);
  }

  function moveSize(card) {
    var size = card.querySelector('.mp-home-size');
    var name = card.querySelector('.mp-home-info h3');
    if (!size || !name || size.classList.contains('mp-size-top')) return;
    size.classList.add('mp-size-top');
    name.parentNode.insertBefore(size, name.nextSibling);
  }

  function enhanceMeters(card) {
    if (handleOf(card) === 'set-recuerdos') {
      var meters = card.querySelector('.mp-home-meters');
      if (meters && !meters.getAttribute('data-mp-set')) {
        meters.setAttribute('data-mp-set', '1');
        meters.innerHTML = SET_INFO.map(function (row) {
          return '<div data-mp="1"><div class="mp-meter-head mp-meter-head--stack"><span>' + row[0] + '</span><em>' + row[1] + '</em>' + (row[2] ? '<small>' + row[2] + '</small>' : '') + '</div></div>';
        }).join('');
      }
      return;
    }
    card.querySelectorAll('.mp-home-meters > div').forEach(function (box) {
      if (box.getAttribute('data-mp')) return;
      var label = box.querySelector('span');
      var value = box.querySelector('strong');
      if (!label || !value) return;
      var n = (value.textContent.match(/●/g) || []).length;
      var key = /DURA/i.test(label.textContent) ? 'duracion' : 'intensidad';
      var bars = '';
      for (var i = 0; i < 5; i++) bars += '<i' + (i < n ? ' class="on"' : '') + '></i>';
      box.innerHTML =
        '<div class="mp-meter-head"><span>' + label.textContent + '</span><em>' + (WORDS[key][n] || '') + '</em></div>' +
        '<div class="mp-meter-bar" role="img" aria-label="' + label.textContent + ': ' + n + ' de 5">' + bars + '</div>';
      box.setAttribute('data-mp', '1');
    });
  }

  function enhanceButton(card) {
    if (card.getAttribute('data-mp-cta')) return;
    var old = card.querySelector('.mp-home-button');
    var handle = handleOf(card);
    if (!old || !handle) return;
    card.setAttribute('data-mp-cta', '1');

    var wrap = document.createElement('div');
    wrap.className = 'mp-card-actions';
    var add = document.createElement('span');
    add.className = 'mp-card-add';
    add.setAttribute('role', 'button');
    add.setAttribute('tabindex', '0');
    add.setAttribute('data-handle', handle);
    add.textContent = 'Agregar al carrito';
    var view = document.createElement('span');
    view.className = 'mp-card-view';
    view.textContent = 'Ver perfume';
    wrap.appendChild(add);
    wrap.appendChild(view);
    old.parentNode.replaceChild(wrap, old);

    getProduct(handle).then(function (p) {
      if (!p) return;
      var available = (p.variants || []).some(function (v) { return v.available; });
      if (!available) {
        add.classList.add('is-soldout');
        add.textContent = 'Agotado';
        add.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function addToCart(btn) {
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-soldout')) return;
    var handle = btn.getAttribute('data-handle');
    var original = btn.getAttribute('data-label') || 'Agregar al carrito';
    btn.classList.add('is-loading');
    btn.textContent = 'Agregando…';

    getProduct(handle).then(function (p) {
      var variant = p && (p.variants || []).filter(function (v) { return v.available; })[0];
      if (!variant) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-soldout');
        btn.textContent = 'Agotado';
        return;
      }
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender
        ? drawer.getSectionsToRender().map(function (s) { return s.id; })
        : [];
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variant.id, quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.classList.remove('is-loading');
          if (data && data.status) {
            btn.textContent = 'Sin existencias';
            setTimeout(function () { btn.textContent = original; }, 2200);
            return;
          }
          btn.classList.add('is-added');
          btn.textContent = 'Agregado ✓';
          setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = original; }, 2200);
          if (drawer && drawer.renderContents && data.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else {
            window.location.href = root() + 'cart';
          }
        });
    }).catch(function () {
      btn.classList.remove('is-loading');
      btn.textContent = original;
    });
  }


  /* ===== Video de inicio: fondo ambiental y acceso a la colección ===== */
  function enhanceHero() {
    var hero = document.getElementById('mpTepesHero');
    if (!hero || hero.getAttribute('data-mp-hero')) return;
    hero.setAttribute('data-mp-hero', '1');
    var video = hero.querySelector('.mp-tepes-hero__video');

    // Segundo botón: lleva a la Galería de Recuerdos
    var copy = hero.querySelector('.mp-reveal-copy');
    var cta = hero.querySelector('.mp-reveal-cta');
    var shop = document.querySelector('.mp-home-shop');
    if (copy && cta && shop) {
      var row = document.createElement('div');
      row.className = 'mp-hero-actions';
      cta.parentNode.insertBefore(row, cta);
      row.appendChild(cta);
      var link = document.createElement('a');
      link.className = 'mp-hero-secondary';
      link.href = '#mpHomeCarousel';
      link.textContent = 'Descubrir la colección';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var top = shop.getBoundingClientRect().top + window.pageYOffset - 70;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
      row.appendChild(link);
    }

    // Fondo ambiental difuminado (solo escritorio), sin descargar el video otra vez
    if (!video || !window.matchMedia('(min-width: 750px)').matches) return;
    var canvas = document.createElement('canvas');
    canvas.className = 'mp-hero-ambient';
    canvas.width = 96;
    canvas.height = 120;
    canvas.setAttribute('aria-hidden', 'true');
    hero.insertBefore(canvas, hero.firstChild);
    hero.classList.add('has-ambient');
    var ctx = canvas.getContext('2d');
    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(hero);
    }
    var last = 0;
    function draw(now) {
      if (!hero.isConnected) return;
      if (visible && now - last > 66 && video.readyState >= 2) {
        try { ctx.drawImage(video, 0, 0, canvas.width, canvas.height); } catch (err) {}
        last = now;
      }
      requestAnimationFrame(draw);
    }
    requestAnimationFrame(draw);
  }

  /* ===== ¿Por qué Memories Parfums? ===== */
  var WHY = [
    ['Hecho en México', 'Alta perfumería de autor.'],
    ['Nacido de un recuerdo', 'Cada fragancia cuenta una historia.'],
    ['Envío a México y EUA', 'Preparado a mano, llega impecable.'],
    ['Materias primas selectas', 'Ingredientes de calidad mundial.']
  ];

  function scrollToShop(e) {
    var shop = document.querySelector('.mp-home-shop');
    if (!shop) return;
    e.preventDefault();
    window.scrollTo({ top: shop.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' });
  }

  function enhanceWhy() {
    var sec = document.querySelector('[id$="__multicolumn_7KQxky"]');
    if (!sec || sec.getAttribute('data-mp-why')) return;
    sec.setAttribute('data-mp-why', '1');
    sec.classList.add('mp-why');
    var title = sec.querySelector('.title');
    if (title) {
      title.innerHTML = '<span class="mp-why__eyebrow">Por qué Memories Parfums</span>Cada perfume comienza con un recuerdo.';
    }
    sec.querySelectorAll('.multicolumn-list__item').forEach(function (item, i) {
      var info = item.querySelector('.multicolumn-card__info');
      if (!info || !WHY[i]) return;
      info.innerHTML = '<h3 class="mp-why__title">' + WHY[i][0] + '</h3><p class="mp-why__text">' + WHY[i][1] + '</p>';
    });
    var list = sec.querySelector('.multicolumn-list');
    if (list) {
      var cta = document.createElement('a');
      cta.className = 'mp-why__cta';
      cta.href = '#mpHomeCarousel';
      cta.textContent = 'Descubrir la colección';
      cta.addEventListener('click', scrollToShop);
      var holder = list.closest('slider-component') || list;
      holder.parentNode.insertBefore(cta, holder.nextSibling);
    }
  }

  /* ===== Bestseller: Kiyomizu-dera ===== */
  var BS_VIDEO = 'https://cdn.shopify.com/videos/c/vp/8805f58a77ae4f718bb357ed9966d99d/8805f58a77ae4f718bb357ed9966d99d.';
  var BS_POSTER = 'https://cdn.shopify.com/s/files/1/0789/4443/6470/files/Memories-Kiyomizu-dera-poster.jpg?v=1793669260';
  function bsMedia(fallbackSrc) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return '<img src="' + (BS_POSTER || fallbackSrc) + '&width=1080" alt="Kiyomizu-dera, Memories Parfums" loading="lazy">';
    var file = window.matchMedia('(min-width: 750px)').matches ? 'HD-1080p-2.5Mbps-99803079.mp4' : 'HD-720p-1.6Mbps-99803079.mp4';
    return '<video class="mp-bs__video" autoplay muted loop playsinline preload="metadata" poster="' + BS_POSTER + '&width=1080" aria-label="Kiyomizu-dera, Memories Parfums">' +
      '<source src="' + BS_VIDEO + file + '" type="video/mp4"></video>';
  }

  function enhanceBestseller() {
    var box = document.querySelector('.mp-restock-feature');
    if (!box || box.getAttribute('data-mp-bs')) return;
    box.setAttribute('data-mp-bs', '1');
    box.classList.add('mp-bs');
    var img = box.querySelector('.mp-restock-media img');
    var src = img ? img.getAttribute('src') : '';
    box.innerHTML =
      '<div class="mp-restock-media mp-bs__media">' + bsMedia(src) + '</div>' +
      '<div class="mp-restock-content mp-bs__content">' +
        '<p class="mp-bs__eyebrow">Bestseller · Tercera producción</p>' +
        '<h2>Kiyomizu-dera</h2>' +
        '<p class="mp-bs__lead">El Templo de Agua Pura, en un frasco.</p>' +
        '<p class="mp-bs__proof">Dos producciones agotadas. Lote limitado: cuando se termine, habrá que esperar al siguiente.</p>' +
        '<p class="mp-bs__notes">Bambú · Menta · Iris · Incienso</p>' +
        '<div class="mp-bs__actions">' +
          '<span class="mp-card-add" role="button" tabindex="0" data-handle="kiyomizu-dera">Agregar al carrito</span>' +
          '<a class="mp-card-view" href="' + root() + 'products/kiyomizu-dera">Descubrir el perfume</a>' +
        '</div>' +
      '</div>';
    var vid = box.querySelector('video');
    if (vid) {
      vid.muted = true;
      var p0 = vid.play();
      if (p0 && p0.catch) p0.catch(function () {});
    }
    getProduct('kiyomizu-dera').then(function (p) {
      if (!p) return;
      var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
      var addBtn = box.querySelector('.mp-card-add');
      if (v && addBtn && p.available) {
        var label = 'Agregar al carrito · ' + formatMoney(v.price / 100).replace('.00', '') + ' MXN';
        addBtn.setAttribute('data-label', label);
        if (!addBtn.classList.contains('is-loading')) addBtn.textContent = label;
      }
      if (!p.available) {
        var btn = box.querySelector('.mp-card-add');
        btn.classList.add('is-soldout');
        btn.textContent = 'Agotado';
      }
    });
  }

  /* ===== Tienda: tarjetas editoriales ===== */
  var ASSET_BASE = (document.currentScript && document.currentScript.src) ? document.currentScript.src.replace(/mp-enhance\.js.*$/, '') : '';
  function loadShopCss() {
    if (!ASSET_BASE || document.getElementById('mp-shop-css')) return;
    var l = document.createElement('link');
    l.id = 'mp-shop-css';
    l.rel = 'stylesheet';
    l.href = ASSET_BASE + 'mp-shop.css';
    document.head.appendChild(l);
  }

  function enhanceEditorial(card) {
    if (card.getAttribute('data-mp-ed')) return;
    var handle = handleOf(card);
    if (!handle) return;
    card.setAttribute('data-mp-ed', '1');
    var isSet = handle === 'set-recuerdos';
    var info = card.querySelector('.mp-editorial-info');
    var name = info && info.querySelector('h2');
    var size = info && info.querySelector('.mp-editorial-size');
    var meters = info && info.querySelector('.mp-editorial-meters');
    var price = info && info.querySelector('.mp-editorial-price');
    var old = info && info.querySelector('.mp-editorial-button');
    if (!info || !name) return;

    if (size) {
      if (isSet) size.textContent = '9 perfumes · 3 ml cada uno';
      size.classList.add('mp-size-top');
      name.parentNode.insertBefore(size, name.nextSibling);
    }

    if (meters) {
      if (isSet) {
        meters.innerHTML = SET_INFO.map(function (row) {
          return '<div data-mp="1"><div class="mp-meter-head mp-meter-head--stack"><span>' + row[0] + '</span><em>' + row[1] + '</em>' + (row[2] ? '<small>' + row[2] + '</small>' : '') + '</div></div>';
        }).join('');
      } else {
        meters.querySelectorAll(':scope > div').forEach(function (box) {
          var label = box.querySelector('span');
          var value = box.querySelector('strong');
          if (!label || !value) return;
          var n = (value.textContent.match(/●/g) || []).length;
          var key = /DURA/i.test(label.textContent) ? 'duracion' : 'intensidad';
          var bars = '';
          for (var i = 0; i < 5; i++) bars += '<i' + (i < n ? ' class="on"' : '') + '></i>';
          box.innerHTML =
            '<div class="mp-meter-head"><span>' + label.textContent + '</span><em>' + (WORDS[key][n] || '') + '</em></div>' +
            '<div class="mp-meter-bar" role="img" aria-label="' + label.textContent + ': ' + n + ' de 5">' + bars + '</div>';
          box.setAttribute('data-mp', '1');
        });
      }
    }

    var msi = null;
    if (price && !isSet) {
      msi = document.createElement('p');
      msi.className = 'mp-card-msi';
      price.parentNode.insertBefore(msi, price.nextSibling);
    }

    if (old) {
      var wrap = document.createElement('div');
      wrap.className = 'mp-card-actions';
      wrap.innerHTML = '<span class="mp-card-add" role="button" tabindex="0" data-handle="' + handle + '">Agregar al carrito</span><span class="mp-card-view">Ver perfume</span>';
      old.parentNode.replaceChild(wrap, old);
    }

    getProduct(handle).then(function (p) {
      if (!p) return;
      var max = 0;
      (p.variants || []).forEach(function (v) { if (v.price > max) max = v.price; });
      if (max && price) {
        var amount = max / 100;
        price.textContent = formatMoney(amount).replace('.00', '') + ' MXN';
        if (msi) msi.innerHTML = '<span>6 meses sin intereses</span><small>' + formatMoney(amount / 6) + ' al mes</small>';
      }
      if (!p.available) {
        var add = card.querySelector('.mp-card-add');
        if (add) { add.classList.add('is-soldout'); add.textContent = 'Agotado'; add.setAttribute('aria-disabled', 'true'); }
      }
    });
  }

  function addSetPromo(grid) {
    if (grid.querySelector('.mp-set-promo')) return;
    var cards = grid.querySelectorAll('.mp-editorial-card');
    if (cards.length < 5) return;
    var promo = document.createElement('a');
    promo.className = 'mp-set-promo';
    promo.href = root() + 'products/set-recuerdos';
    promo.innerHTML =
      '<span class="mp-set-promo__eyebrow">¿No sabes cuál elegir?</span>' +
      '<span class="mp-set-promo__title">Prueba toda la colección con el Set Recuerdos</span>' +
      '<span class="mp-set-promo__text">9 perfumes de 3 ml · $250 MXN de bonificación en tu siguiente botella</span>' +
      '<span class="mp-set-promo__cta">Descubrir el set</span>';
    cards[3].parentNode.insertBefore(promo, cards[3].nextSibling);
  }

  function enhanceShop() {
    var grid = document.querySelector('.mp-editorial-grid');
    if (!grid) return;
    loadShopCss();
    grid.querySelectorAll('.mp-editorial-card').forEach(enhanceEditorial);
    addSetPromo(grid);
  }

  function init() {
    enhanceShop();
    enhanceHero();
    enhanceWhy();
    enhanceBestseller();
    document.querySelectorAll('.mp-home-card').forEach(function (card) {
      moveSize(card);
      enhanceMeters(card);
      enhanceMsi(card);
      enhanceButton(card);
    });
  }

  document.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mp-card-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.detail !== 0 && (Math.abs(e.clientX - downX) > 10 || Math.abs(e.clientY - downY) > 10)) return;
    addToCart(btn);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest && e.target.closest('.mp-card-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
